import { jwtDecode } from "jwt-decode";

type JwtPayload = {
  exp?: number;
};

export function validateToken(token: string): boolean {
  try {
    const payload = jwtDecode<JwtPayload>(token);
    return payload.exp ? Date.now() < payload.exp * 1000 : false;
  } catch (err) {
    console.warn("Failed to validate token:", err);
    return false;
  }
}
